import { toast } from "react-toastify"; // Import toast notifications for user feedback
import routes from "../../../Routes/routes"; // Import application routes
import { CreateListSupplier, UploadSupplierFormFile } from "../../../reduxToolkit/Files/FilesApi";
import {errorMsg} from "../../../Apis/functions"; // Import API actions for supplier file upload and creation

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

// This function handles the logic for uploading and validating supplier files, and creating supplier entries
export const CreationErrorsSupplierApp = ({
                                              t, // Translation function (i18next)
                                              dispatch, // Redux dispatch function
                                              navigate, // Function to navigate between routes
                                              spreadsheetData, // The file data that was uploaded by the user
                                              data, // The validated supplier data ready for submission
                                              setUpdate, // Function to update a state variable (e.g. loading or status)
                                              getFormData, // Function to create a FormData object with the file
                                              isValidFile, // Callback to mark the file as valid or process its content
                                          }) => {

    // Function to handle the upload of the spreadsheet file
    const handleUploadFile = () => {
        setUpdate(true); // Indicate that an update operation is starting

        // Proceed only if spreadsheet data exists
        if (spreadsheetData) {
            let data = getFormData(); // Prepare FormData from the uploaded file

            if (data) {
                // Dispatch Redux action to upload the file to the backend
                dispatch(UploadSupplierFormFile(getFormData()))
                    .then(
                        ({
                             payload: {
                                 data: { data, success },
                             },
                         }) => {
                            // If upload is successful, proceed with validation
                            if (success === true) {
                                isValidFile(data); // Process and validate file content
                            }
                        },
                    )
                    .catch(() => {
                        // Show an error toast if something goes wrong
                        toast.error(t('fail_to_upload_file').toUpperCase());
                    });
            }
        } else {
            // Warn the user that no file was provided
            toast?.warn(t('there_is_not_file_to_upload').toUpperCase());
        }
    };

    // Function to confirm and submit the validated supplier data to be created
    const handleConfirm = () => {
        dispatch(CreateListSupplier(data)) // Dispatch action to create supplier records
            .then(({ payload: { data: { success, code } } }) => {
                if (success === true) {
                    // Show success notification and redirect to supplier list page
                    toast.success(t('has_been_created_successfully'));
                    navigate(routes.suppliers.main);
                } else errorMsg(code)
            });
    };

    // Return the functions to be used in the UI component
    return {
        handleConfirm,
        handleUploadFile,
    };
};

// Export this logic container so it can be used in a React component
export default CreationErrorsSupplierApp;
